import React from "react";

import { FooterPC } from "./footer.pc";
import { FooterMobile } from "./footer.mobile";
import { useIsMobile } from "../../hooks/is.mobile";

export const Footer: React.FC<any> = () => {
  const isMobile = useIsMobile();
  return (
    <div style={{ width: "100vw" }}>
      {isMobile ? <FooterMobile /> : <FooterPC />}{" "}
    </div>
  );
};
